// Site configuration constants
// Update these values as needed

// Contact Information
export const CONTACT_EMAIL = 'jose.mindfuljr@gmail.com';
export const EMAIL_SUBJECT = 'Mindfulness Consultation';

// Scheduling
export const ZOOM_SCHEDULING_LINK = 'http://scheduler.zoom.us/mindfuljr';
// Zoom Scheduler is handled through my Zoom account.
// - create an event
// - add it to the scheduler availability
// - it should show up in the calendar linked here

// Social Media Links
export const INSTAGRAM_URL = 'https://www.instagram.com/monkeymind716/';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/jrvisuals/';

// Blog
export const BLOG_URL = 'https://blog.mindfuljr.com/';

// Branding/Identity
export const SITE_NAME = 'MindfulJR';
export const BRAND_SUBTITLE = 'Mindfulness with Jose Rodriguez';
export const FULL_NAME = 'Jose Rodriguez';

// Developer/Company Info
export const DEVELOPER_COMPANY_NAME = 'JRVisuals';
export const DEVELOPER_WEBSITE_URL = 'https://www.JRVisuals.com/';
export const DEVELOPER_ATTRIBUTION_TEXT = 'Site developed by';

